<script>
import {Listeners} from "../../../constants/listeners";

export default {
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    methods: {
        submitFormFilter() {
            this.$emitter.emit(Listeners.KS_FILTER_SUBMIT_FORM);
        },

    },
    async created() {
        if (!this.item.value.length && this.item.items && this.item.items.length > 0) {
            this.item.value.push(this.item.items[0].value)
        }
    },
}
</script>

<template>
    <select class="fieldselect" v-model="item.value" multiple size="5">
        <option v-for="v in item.items" v-bind:value="v.value" v-text="v.label"></option>
    </select>
</template>

